import React from 'react';
import { componentTypes } from '@white-nl/instantsearch-components';

export default function Loading({ additionalData }: componentTypes.LoadingProps) {
  const { hitsPerPage } = additionalData;

  return (
    <>
      {[...Array(hitsPerPage).keys()].map((i) => (
        <div className="col" key={i}>
          <div className="card-news">
            <div className="card-news-img">
              <div className="card-news-head">
                <div className="time placeholder-glow">
                  <span className="placeholder col-3" />
                </div>
                <div className="h4 placeholder-glow">
                  <span className="placeholder col-10" />
                </div>
                <div className="fs-5 mb-1 placeholder-glow">
                  <span className="placeholder col-12" />
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </>
  );
}
